export default "https://static.homerun-beta.co/images/close.png?de98df0f4749844e52d8225627607961";